import ActionFailException from "./exceptions/ActionFailException";

export const HUBSPOT_API_URL = "https://api.hsforms.com/submissions/v3/integration/submit";

export const HUBSPOT_REQUIST_INIT = {
	method: "POST",
	headers: {
		"Content-Type": "application/json",
	},
};

export const hubspotBody = (fields, submittedAt = Date.now()) =>
	JSON.stringify({ submittedAt, fields });

export const entriesToFields = form =>
	Object.entries(form).map(([name, value]) => ({ name, value }));

const errorsToMessage = errors => {
	return errors.map(({ errorType }) => `errors.${errorType}`);
};

const getHubspotErrorMessage = response =>
	response
		.json()
		.then(result =>
			Array.isArray(result.errors)
				? errorsToMessage(result.errors)
				: `${response.status} - ${result.message}`,
		);

/**
 * Factory creates a hubspot form
 *
 * @type {<F extends {} = Record<string, any>(
 *   portalId: string,
 *   formGuid: string,
 *   mapForm?: (form: F) => Array<{ name: string, value: any }>
 * ) => { submit(form: F): Promise<void> }}
 */
const HubspotForm = (portalId, formGuid, mapForm = entriesToFields) => {
	const formUrl = `${HUBSPOT_API_URL}/${portalId}/${formGuid}`;

	const submit = form =>
		fetch(formUrl, {
			...HUBSPOT_REQUIST_INIT,
			body: hubspotBody(mapForm(form)),
		})
			.then(response => (response.ok ? null : getHubspotErrorMessage(response)))
			.then(errorMessage => {
				if (errorMessage == null) return;
				throw new ActionFailException(errorMessage, 400);
			});

	return { submit };
};

export default HubspotForm;
